import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';

const ProductViewHeaderSkeleton = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <div className="relative z-10 mt-4 sm:mt-8">
      <div className="max-w-[1495px] w-full mx-auto px-3 sm:px-4">
        <div className={`rounded-xl sm:rounded-2xl shadow-lg px-4 sm:px-6 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 transition-all duration-500 ${
          isDarkMode 
            ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50' 
            : 'bg-white'
        }`}>
          {/* Breadcrumbs Skeleton */}
          <div className="flex items-center text-xs sm:text-sm gap-1 sm:gap-2 overflow-hidden">
            {/* Marketplace skeleton */}
            <div className={`h-4 w-20 rounded animate-pulse ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            }`}></div>
            
            {/* Chevron skeleton */}
            <div className={`w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            } rounded animate-pulse`}></div>
            
            {/* Category skeleton */}
            <div className={`h-4 w-24 rounded animate-pulse ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            }`}></div>
            
            {/* Chevron skeleton */}
            <div className={`w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            } rounded animate-pulse`}></div>
            
            {/* Product title skeleton */}
            <div className={`h-4 w-32 sm:w-48 rounded animate-pulse ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            }`}></div>
          </div>
          
          {/* Cart and Wishlist Icons Skeleton */}
          <div className="flex items-center gap-2 sm:gap-3">
            {/* Cart Icon Skeleton */}
            <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full animate-pulse ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            }`}></div>
            
            {/* Wishlist Icon Skeleton */}
            <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full animate-pulse ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
            }`}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductViewHeaderSkeleton;
